import React, { ReactNode, FC, useMemo } from 'react';
import { ResponsiveProps } from 'ia-react-core/~/interfaces/ResponsiveProps';
import UnionControlGroupContext from '../_UnionControlGroupContext';
import ControlGroup from '../ControlGroup';
import { StyledWrapper } from './UnionControlGroup.styles';
import useResponsiveProps from '../../../hooks/useResponsiveProps';

const RESPONSIVE_PROPS = ['split'] as const;

type UnionControlGroupResponsiveProps = {
  /** Width to split the controls. String seperated by slashes. */
  split?: string;
};

export interface UnionControlGroupProps extends UnionControlGroupResponsiveProps, ResponsiveProps<UnionControlGroupResponsiveProps> {
  /** The children */
  children: ReactNode;
}

const UnionControlGroupDefaultprops = {
  split: '50%/50%',
};

/**
 * @mode developer
 */
const UnionControlGroup: FC<UnionControlGroupProps> = ({ children, ...props }) => {
  const unionControlGroupContext = useMemo(() => ({
    isUnionControlGroup: true,
  }), []);

  const resolvedCols = useResponsiveProps(props, RESPONSIVE_PROPS);

  return (
    <UnionControlGroupContext.Provider value={unionControlGroupContext}>
      <ControlGroup>
        <StyledWrapper {...resolvedCols}>
          {children}
        </StyledWrapper>
      </ControlGroup>
    </UnionControlGroupContext.Provider>
  );
};

UnionControlGroup.defaultProps = UnionControlGroupDefaultprops;
UnionControlGroup.displayName = 'UnionControlGroup';

export default UnionControlGroup;
